module.exports = __webpack_public_path__ + "static/media/Workday_Step2d_Image7g.944edf5c.jpg";